import { Asset } from "../Asset";
export class Ellipse extends Asset {
    constructor(width, height, color) {
        super();
        this.width = width;
        this.height = height;
        this.color = color;
    }
    draw(ctx, owner) {
        ctx.fillStyle = this.color;
        let x = owner.position.getX();
        let y = owner.position.getY();
        ctx.beginPath();
        ctx.ellipse(x + this.width, y + this.width, this.width, this.height, owner.rotation, 0, 360);
        ctx.fill();
    }
}
//# sourceMappingURL=Ellipse.js.map